import clsx from 'clsx'
import type { ChangeEvent, InputHTMLAttributes } from 'react'
import type { InputInFormProps } from '~/components/Form/Input/input'
import {
  checkBoxLabel,
  checkboxStyle,
  checkboxStyleMedium,
  checkboxStyleSecondary
} from './Checkbox.css'

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
  colorPalette?: 'primary' | 'secondary' | 'medium'
  label?: string
  onChange?: (checked: boolean, e: ChangeEvent<HTMLInputElement>) => void
} & InputInFormProps

export const Checkbox = ({
  onChange,
  colorPalette = 'primary',
  label,
  watch,
  control,
  register,
  setValue,
  defaultChecked,
  name,
  ...rest
}: CheckboxProps) => {
  if (register !== undefined && name !== undefined) {
    register(name)
  }
  const input = (
    <input
      type="checkbox"
      onChange={(e) => {
        onChange?.(e.target.checked, e)
        if (setValue !== undefined && name !== undefined) {
          setValue(name, e.target.checked)
        }
      }}
      className={clsx(
        checkboxStyle,
        colorPalette === 'secondary' && checkboxStyleSecondary,
        colorPalette === 'medium' && checkboxStyleMedium
      )}
      defaultChecked={
        watch !== undefined && name !== undefined ? watch(name) : defaultChecked
      }
      {...rest}
    />
  )

  if (!label) {
    return input
  }

  return (
    <label className={checkBoxLabel}>
      {input}
      {label}
    </label>
  )
}
